module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/roller-88d47e8e0c30a279a16fb0c122eb1331.svg";